'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface BulkActionsProps {
  selectedPlans: string[];
  onCompare: (planIds: string[]) => void;
  onBulkDelete: (planIds: string[]) => void;
  onBulkExport: (planIds: string[]) => void;
  onDeselectAll: () => void;
}

const BulkActions = ({ 
  selectedPlans, 
  onCompare, 
  onBulkDelete, 
  onBulkExport, 
  onDeselectAll 
}: BulkActionsProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated || selectedPlans.length === 0) {
    return null;
  }

  return (
    <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center space-x-3">
          <Icon name="CheckCircleIcon" size={20} className="text-primary" />
          <span className="text-sm font-medium text-foreground">
            {selectedPlans.length} plan{selectedPlans.length > 1 ? 's' : ''} selected
          </span>
        </div>

        <div className="flex items-center space-x-2">
          {selectedPlans.length >= 2 && selectedPlans.length <= 4 && (
            <button
              onClick={() => onCompare(selectedPlans)}
              className="flex items-center space-x-2 px-3 py-2 bg-secondary text-secondary-foreground text-sm font-medium rounded-md hover:bg-secondary/90 transition-colors duration-200"
            >
              <Icon name="ArrowsRightLeftIcon" size={16} />
              <span>Compare Plans</span>
            </button>
          )}

          <button
            onClick={() => onBulkExport(selectedPlans)}
            className="flex items-center space-x-2 px-3 py-2 bg-accent text-accent-foreground text-sm font-medium rounded-md hover:bg-accent/90 transition-colors duration-200"
          >
            <Icon name="ArrowDownTrayIcon" size={16} />
            <span>Export</span>
          </button>

          <button
            onClick={() => onBulkDelete(selectedPlans)}
            className="flex items-center space-x-2 px-3 py-2 bg-error text-error-foreground text-sm font-medium rounded-md hover:bg-error/90 transition-colors duration-200"
          >
            <Icon name="TrashIcon" size={16} />
            <span>Delete</span>
          </button>

          <button
            onClick={onDeselectAll}
            className="flex items-center space-x-2 px-3 py-2 text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors duration-200"
          >
            <Icon name="XMarkIcon" size={16} />
            <span>Deselect All</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;